/* PagingOsPlanFeed.js */

"use strict";
const PagingFeed = require("../../../../lib/PagingFeed");

class PagingIotOsPlanFeed extends PagingFeed {
    _getFeed() {
        return this._EntityDef.startOdmOsUpgradePlansFeed(
            this._userSession.activeOrganization.id,
            this._filter,
            this._entityFields,
            this._sort,
            {
                skip: 0,
                limit: this._pageSize * 2,
            }
        );
    }

    _getFeedIdsForSelection(tenantId, selection) {
        return this._EntityDef.loadOdmOsUpgradePlanIdsForSelection(tenantId, selection);
    }

    getIotOsPlanEntitiesById(ids) {
        return this.getEntitiesByIdAsProm(ids);
    }

    getIotOsPlanEntitiesNameById(ids) {
        return this.getEntitiesValueByIdAsProm(ids, "name");
    }

    getIotOsPlanEntityById(id) {
        return this.getEntityById(id);
    }

    getIotOsPlanEntitiesStatusById(ids) {
        return this.getEntitiesValueByIdAsProm(ids, "status");
    }

    getIotOsPlanEntitiesNameAndStatusById(ids) {
        return this.getEntitiesValuesByIdAsProm(ids, ["name", "status"]);
    }
}

module.exports = PagingIotOsPlanFeed;
